<template>
    <div>
        <div
          :style="{transform: is_print ? 'scale(0.85)' : '', 'max-height': max_height, 'transform-origin': is_print ? '0 0' : '', width: is_print ? '117.647058824% !important' : ''}"
          >
            <lessons-table-header :lessons="lessons" v-if="students.length > 0" :print="is_print">
            </lessons-table-header>
            <div v-show="is_print && students.length > 0">
                <div class="my-3" />
                <v-divider />
                <div class="my-2" />
            </div>
            <lessons-table v-if="students.length > 0" :students="students" :hover="false" :print="is_print">
                <template v-slot:lesson="props">
                    <school-cell :readonly="true" :identifier="props.identifier" :allowed_menu="false" :value="props.lesson.state" :dark="$vuetify.theme.dark">
                    </school-cell>
                </template>
                <template v-slot:student="props">
                    <v-chip :style="{background: is_print ? 'none' : ''}">{{ nameify(props.student) }}</v-chip>
                </template>
            </lessons-table>
            <div v-show="is_print && students.length > 0">
                <v-divider />
                <div class="my-2 d-none d-print-block" />
            </div>
            <v-row class="pt-4 px-3">
                <div cols="grow" class="d-none d-print-block text-left body-2 font-italic text--secondary pt-2 pr-2">generated on {{generated_date}}</div>
                <v-spacer />
                <div cols="auto" align="right" class="text-right body-2 font-italic text--secondary pt-2 pr-2" v-html="validity_message"></div>
            </v-row>
        </div>
        <v-progress-circular v-if="students.length == 0" indeterminate
          style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%)"/>
    </div>
</template>

<style>
@page {
  size: A4 portrait;
}
</style>

<script>
import LessonsTable from './LessonsTable.vue'
import LessonsTableHeader from './LessonsTableHeader.vue'
import SchoolCell from './SchoolCell.vue'

export default {
    name: 'CleanLessonsView',

    components: {
        LessonsTable,
        LessonsTableHeader,
        SchoolCell,
    },

    props: {
        lessons: {
            type: Array,
            default: () => []
        },
        students: {
            type: Array,
            default: () => []
        },
        validity: Object
    },

    data: () => ({
    }),

    computed: {
        validity_message () {
            if (this.validity.start_date && this.validity.end_date) {
                return "valid " + this.format_date(this.validity.start_date) + " &ndash; " + this.format_date(this.validity.end_date)
            } else if (this.validity.start_date) {
                return "valid from " + this.format_date(this.validity.start_date)
            } else if (this.validity.end_date) {
                return "valid until " + this.format_date(this.validity.end_date)
            } else {
                return null
            }
        },
        generated_date () {
            var date = new Date();
            var options = { hour: 'numeric', minute: 'numeric'};
            return date.toLocaleDateString('en-CH', options).replaceAll('/', '.');
        },
        is_print () {
            return 'p' in this.$route.query;
        },
        max_height () {
            if (this.is_print && this.students.length > 0) {
                return `${43 * this.students.length + 100}px`;
            } else if (this.is_print && this.students.length == 0) {
                return '0px';
            } else {
                return null;
            }
        }
    },
    methods: {
        nameify (student) {
            if (this.$vuetify.breakpoint.xs) {
                return student.first_name[0] + student.last_name[0]
            } else if (this.$vuetify.breakpoint.width < 1500) {
                return student.first_name.split(' ')[0] + ' ' + student.last_name[0] + '.'
            }
            return student.first_name + ' ' + student.last_name
        },
        format_date (iso_date) {
            var date = new Date(iso_date);
            var date_string = date.toDateString().split(' ');
            return date_string[1] + ' ' + parseInt(date_string[2], 10);
        }
    },
    created () {
        document.addEventListener("contextmenu", function (e) {
            e.preventDefault()
        }, false)
    }
};

</script>

<style>
</style>
